import React, { forwardRef, useCallback, useEffect, useRef } from 'react';
import { throttle } from 'lodash';
import { useField, useFormikContext } from 'formik';
import { useTranslation } from 'react-i18next';
import ReactTextareaAutosize from 'react-textarea-autosize';
// import upd from 'immutability-helper';

import { useAccessToken } from '../../hooks';
import { useChatBodyContext } from '../../chat-body-context';

import { useSetTyping } from './hooks';

const Content = forwardRef<HTMLTextAreaElement>((props, forwardedRef) => {
  const { quotedMessage } = useChatBodyContext();
  const { isSubmitting, submitForm } = useFormikContext();

  // const [attachsField, , attachsHelpers] = useField<File[]>('attachs');
  const [field, , helpers] = useField<string>('content');
  const { accessToken } = useAccessToken();
  const { t } = useTranslation();
  const ref = forwardedRef || useRef<HTMLTextAreaElement>(null);
  const setTyping = useSetTyping();

  const typing = useCallback(
    throttle(() => setTyping(), 3000, { trailing: false }),
    [accessToken],
  );

  useEffect(() => {
    if (!quotedMessage) return;
    else if (typeof ref != 'object') return;

    ref.current?.focus();
  }, [quotedMessage]);

  const handleChange = (value: string) => {
    helpers.setValue(value);
    if (value == '') return;

    typing();
  };

  const handleKeyDown: React.KeyboardEventHandler<HTMLTextAreaElement> = e => {
    if (e.code != 'Enter' && e.code != 'NumpadEnter') return;
    else if (e.shiftKey) return;
    else if (isSubmitting) return;

    e.preventDefault();
    submitForm();
  };

  // const handlePaste: React.ClipboardEventHandler<HTMLTextAreaElement> = e => {
  //   const {clipboardData} = e;

  //   const files = Object.values(clipboardData.files);
  //   if (!files.length) return;

  //   const newValue = upd(attachsField.value, {$push: files});
  //   attachsHelpers.setValue(newValue);
  //   e.preventDefault();
  // };

  return (
    <ReactTextareaAutosize
      {...field}
      className="whatcrm-widget-chat__input"
      onChange={e => handleChange(e.target.value)}
      onKeyDown={handleKeyDown}
      // onPaste={handlePaste}
      placeholder={t`Send a message`}
      ref={ref}
    />
  );
});

Content.displayName = 'MessageInput';
export default Content;
